<template>
  <v-card :loading="!info" elevation="0" class="w-100">
    <div v-if="info">
      <v-progress-linear
        indeterminate
        class="my-3"
        v-if="loading || loadingPage"
        color="primary"
      ></v-progress-linear>
      <qrTextField
        v-model="info.setting.name"
        @click="editShopLine"
        :editShopValue.sync="info"
        edit
        v-if="!loading && !loadingPage"
      />
    </div>
  </v-card>
</template>

<script>
import qrTextField from "../../floor/qrTextField.vue";
export default {
  components: { qrTextField },
  props: {
    info: Object,
    loadingPage: Boolean,
    admin: Boolean,
    qrland: [String, Number],
    update: Function,
  },
  data() {
    return {
      loading: false,
      infos: {},
    };
  },
  methods: {
    async editShopLine(e) {
      this.loading = true;
      try {
        if (this.info.qr_id === e.qr_id) {
          const newSetting = {
            ...this.info,
            alias: e.pay.button.title,
            use_type: e.pay.use_type,
            rent: e.pay?.rent?.rent ?? 0,
            rend_due_days: e.pay?.rent?.rend_due_days ?? 0,
            late_rent_percentage: e.punish.fine
              ? e.pay?.rent?.late_rent_percentage ?? 0
              : 0,
            late_rend_days: e.pay?.rent?.late_rend_days ?? 0,
            charge: e.pay?.charge?.charge ?? 0,
            charge_due_days: e.pay?.charge?.charge_due_days ?? 0,
            late_charge_percentage: e.pay?.charge?.late_charge_percentage ?? 0,
            late_charge_days: e.pay?.charge?.late_charge_days ?? 0,

            type: e.pay.type.value,
            tags: [],
          };
          try {
            await this.$api.put(
              `v1/commercial/${this.qrland}`,
              JSON.stringify(newSetting),
            );
            await this.update();
            this.$toast.success("تغییرات شما با موفقیت اعمال شد");
          } catch (err) {
            this.$toast.error("مشکلی پیش آمده است لطفا دوباره تلاش کنید");
          } finally {
            this.loading = false;
          }
        }
      } catch (errror) {
        this.$toast.error("مشکلی پیش آمده دوباره امتحان کنید");
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    info: {
      deep: true,
      immediate: true,
      handler(val) {
        this.infos = this.info;
      },
    },
  },
};
</script>

<style></style>
